export default __webpack_public_path__ + "static/media/e-merkator-talk-pt.b66bbdb3.png";